import { ReactNode, useCallback } from 'react';
import { Field, FieldRenderProps, RenderableProps } from 'react-final-form';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { ToggleButtonGroup, ToggleButtonGroupProps } from '../components';

export type ToggleButtonGroupFieldProps = Omit<ToggleButtonGroupProps, 'onChange' | 'value'> & {
  children?: ReactNode;
  name: string;
  format?: (value: string) => string;
};

export const ToggleButtonGroupField = (props: ToggleButtonGroupFieldProps) => {
  const { isEditable } = useCanEditFormFieldsContext();
  const { format, disabled: isDisabled = !isEditable } = props;

  const renderInput = useCallback<NonNullable<RenderableProps<FieldRenderProps<string>>['render']>>(
    ({ input }) => {
      return (
        <ToggleButtonGroup
          {...props}
          value={format ? format(input.value) : input.value}
          onChange={input.onChange}
          buttons={props.buttons}
          disabled={isDisabled}
        />
      );
    },
    [props, format, isDisabled],
  );

  return <Field name={props.name} render={renderInput} type='text' />;
};
